import * as api from '../api';

export function getAllTokens(params) {
  return api.get('token', params);
}

export function getOneToken(tokenId) {
  return api.get(`token/${tokenId}`);
}
